import { observable } from "mobx";

export class PulseBetPeriod {

    startTimeInMilli: number;
    endTimeInMilli: number;
    @observable europeanOdds: number;

    constructor(source: PulseBetPeriod) {

        this.startTimeInMilli = source.startTimeInMilli;
        this.endTimeInMilli = source.endTimeInMilli;
        this.europeanOdds = source.europeanOdds;
    }
}